/* eslint-disable react/display-name */
import { microApi } from 'app/services/api';
import { DataObject, IResponseList } from 'app/services/types/IResponse';
import { transformToOptions } from 'app/utils/transforms';

const { useGetListQuery } = microApi;

type Props = {
  // Equivalent to resource url (API)="inspection/type-of-services"
  resource: string;
  isOption?: boolean;
  transformResponse?: (response: IResponseList) => any;
  filter?: any;
  sorter?: any;
  pagination?: {
    current: number;
    pageSize: number;
  };
  [key: string]: any;
};
export function withFetchResource<T>(WrappedComponent: React.ComponentType<T>) {
  return (props: Props & T) => {
    const { resource, filter, sorter, isOption, transformResponse } = props;
    const {
      isLoading,
      // isError,
      isFetching,
      // isSuccess,
      // refetch,
      data: result
    } = useGetListQuery(
      {
        resource,
        current: 1,
        pageSize: 10,
        ...filter,
        ...sorter
      },
      {
        selectFromResult: ({ data: response, ...rest }) => {
          const { data = [] } = response || {};
          if (!data)
            return {
              ...rest,
              data: []
            };
          if (transformResponse) {
            return {
              ...rest,
              ...transformResponse(response)
            };
          }
          if (Array.isArray(data)) {
            return {
              ...rest,
              data: isOption ? transformToOptions(data) : data
            };
          }
          const { list, pagination } = data as DataObject;
          return {
            ...rest,
            data: isOption ? transformToOptions(list) : list,
            pagination
          };
        }
      }
    );

    return (
      <WrappedComponent
        loading={isLoading || isFetching}
        options={isOption ? result : []}
        data={result}
        {...props}
      />
    );
  };
}
